// 用户登录 标记
export const USERINFO_LOGIN = 'USERINFO_LOGIN';
// 更新city name 标记
export const UPDATE_CITYNAME = 'UPDATE_CITYNAME';


// WEBPACK FOOTER //
// ./src/constants/userInfoConstants.js